export class AppConfig {
    static readonly PasswordMinLength = 8;
    static readonly PasswordMaxLength = 128;
}
